import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState, useEffect, setState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import { Button, Label, Input, Tooltip } from 'reactstrap';
import clsx from 'clsx';
import { FiFilter, FiMap, FiList, FiMenu, FiInfo } from 'react-icons/fi';
import { MdCallSplit } from 'react-icons/md';
import useStore from './../store';
import { CPAL_LAYERS, CPAL_LAYER_GROUPS } from './../../../../constants/layers';

var PanelLayersView = function PanelLayersView(_ref) {
  var props = _extends({}, _ref); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Active layers

  var activeLayers = useStore(function (state) {
    return [].concat(state.activeLayers);
  }, shallow);

  var getLayerLabel = function getLayerLabel(id) {
    var layer = CPAL_LAYERS.find(function (gr) {
      return gr.id === id;
    });
    return layer.label;
  };

  var updateLayers = function updateLayers(e) {
    // If item is checked, if it's not in array, push it into array
    // If item is not checked, if it's in array, remove
    var index = Number(String(e.currentTarget.id).replace('layer_', '')); // If the element is an only-one element, reset other only-ones of same name.

    var el = document.getElementById(e.currentTarget.id);
    var dataset = el.dataset;
    var newLayers = activeLayers.slice();

    if (dataset.onlyOne === 'true') {
      // console.log('it is an only-one')
      var name = dataset.onlyOneName; // Remove all the matching only-ones from the activeLayers array.

      CPAL_LAYERS.forEach(function (el, i) {
        if (el.only_one === true && el.only_one_name === name && Number(el.index) !== index) {
          // console.log(
          //   'resetting oneonly, ',
          //   el.id,
          //   el.index,
          // )
          newLayers[Number(el.index)] = 0;
        }
      });
    }

    newLayers[index] = newLayers[index] === 1 ? 0 : 1;
    setStoreValues({
      activeLayers: newLayers
    }); // console.log('activeLayers, ', activeLayers)
  };

  var _useState = useState(0),
      layersKey = _useState[0],
      setLayersKey = _useState[1];

  useEffect(function () {
    // console.log('activeLayers changed')
    setLayersKey(layersKey + 1);
  }, [activeLayers]);
  return /*#__PURE__*/React.createElement("div", {
    className: "map-panel-slideout-layers",
    key: layersKey
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("map-layer-toggle-pane")
  }, CPAL_LAYER_GROUPS.map(function (el, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx('layer-group', 'layer-group-' + i),
      key: 'layer-group-' + i + '-' + layersKey
    }, /*#__PURE__*/React.createElement("h5", {
      key: 'layer-group-header-' + i
    }, i18n.translate(el.title)), /*#__PURE__*/React.createElement("div", {
      key: 'layer-group-desc-' + i,
      className: "layer-group-desc",
      dangerouslySetInnerHTML: {
        __html: i18n.translate(el.desc)
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: clsx('layer-group', 'layer-group-layers-' + i),
      key: 'layer-group-layers-' + i
    }, CPAL_LAYERS.filter(function (item) {
      return item.group === el.id;
    }).map(function (layer, i) {
      // to manage tooltip state
      var _useState2 = useState(false),
          tooltipOpen = _useState2[0],
          setTooltipOpen = _useState2[1];

      var toggle = function toggle() {
        return setTooltipOpen(!tooltipOpen);
      }; // console.log(
      //   'rendering layer checkbox, ',
      //   activeLayers,
      // )


      var isChecked = !!activeLayers[Number(layer.index)];
      return /*#__PURE__*/React.createElement("div", {
        className: "layer",
        key: "layer-" + layer.id,
        id: "layer-" + layer.id
      }, /*#__PURE__*/React.createElement("label", {
        key: "label-" + layer.id,
        id: "label-" + layer.id
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: 'layer_' + layer.index,
        name: "scales",
        key: 'layer-input-' + layer.id,
        "data-only-one": layer.only_one,
        "data-only-one-name": layer.only_one_name,
        checked: isChecked,
        readOnly: true,
        onClick: function onClick(e) {
          updateLayers(e);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "checkmark"
      }), i18n.translate(getLayerLabel(layer.id)), !!el.tooltip && el.tooltip.length > 0 && /*#__PURE__*/React.createElement(FiInfo, {
        id: 'tip_prompt_' + layer.id
      })), !!el.tooltip && el.tooltip.length > 0 && /*#__PURE__*/React.createElement(Tooltip, {
        placement: "top",
        isOpen: tooltipOpen,
        target: 'tip_prompt_' + layer.id,
        toggle: toggle,
        autohide: false,
        className: 'tip-prompt-layer',
        dangerouslySetInnerHTML: {
          __html: i18n.translate(layer.tooltip)
        }
      }));
    })));
  })));
};

export default PanelLayersView;